import * as React from 'react';
import type { TxtProps } from '../../../Txt/TxtBase';
import { FormattedText } from '../../../Txt/TxtBase';
import { OnlineStudyPlanContext } from './Context/OnlineStudyPlanContext';
import type { OnlineStudyTextsViewModel } from './OnlineStudyTextsViewModel.csharp';

export const Txt: React.FC<React.PropsWithChildren<TxtProps<OnlineStudyTextsViewModel>>> = React.memo(
    ({ id, values }) => (
        <OnlineStudyPlanContext.Consumer>
            {({ getText }) => FormattedText(getText(id), values)}
        </OnlineStudyPlanContext.Consumer>
    )
);
